<template>
  <div class="admin-page">
    <Header />
    <div class="header-actions">
      <h2 class="title"><i class="fa-solid fa-users"></i> Gestão de Parceiros</h2>
      <div class="header-actions-buttons">
        <button class="btn-create" @click="openCreateModal"><i class="fa-solid fa-plus"></i> Novo Parceiro</button>
        <router-link to="/admin/dashboard" class="btn-back">Voltar ao Painel</router-link>
      </div>
    </div>

    <div class="card-panel">
      <div class="table-responsive">
        <table class="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Instituição (Parceiro)</th>
              <th>Status</th>
              <th>Acessos Distribuídos</th>
              <th>Materiais Licenciados</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="partner in partners" :key="partner.id">
              <td>#{{ partner.id }}</td>
              <td><strong>{{ partner.name }}</strong><br/><small>{{ partner.email }}</small></td>
              <td>
                <span :class="['status-badge', partner.active ? 'active' : 'inactive']">
                  {{ partner.active ? 'Ativo' : 'Bloqueado' }}
                </span>
              </td>
              <td>{{ partner.used_accesses }} / {{ partner.total_accesses }}</td>
              <td>{{ partner.licensed_materials }} itens</td>
              <td>
                <button class="btn-action view" title="Ver Detalhes" @click="viewDetails(partner)"><i class="fa-solid fa-eye"></i></button>
                <button class="btn-action toggle" @click="toggleStatus(partner)" :title="partner.active ? 'Bloquear Acesso' : 'Desbloquear'">
                  <i :class="['fa-solid', partner.active ? 'fa-lock' : 'fa-unlock']"></i>
                </button>
              </td>
            </tr>
            <tr v-if="partners.length === 0">
              <td colspan="6" class="text-center">Nenhum parceiro encontrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Detalhes do Parceiro -->
    <div class="partner-modal-overlay" v-if="selectedPartner">
      <div class="partner-modal-content">
        <button class="close-btn" @click="closeDetails"><i class="fa-solid fa-times"></i></button>
        <h3><i class="fa-solid fa-building-columns"></i> Detalhes: {{ selectedPartner.name }}</h3>
        
        <div class="partner-grid">
          <div class="partner-info">
            <p><strong>Email:</strong> {{ selectedPartner.email }}</p>
            <p><strong>CNPJ:</strong> 12.345.678/0001-99</p>
            <p><strong>Status:</strong> <span :class="['status-badge', selectedPartner.active ? 'active' : 'inactive']">{{ selectedPartner.active ? 'Ativo' : 'Bloqueado' }}</span></p>
            <p><strong>Acessos Ativados:</strong> {{ selectedPartner.used_accesses }} de {{ selectedPartner.total_accesses }}</p>
            
            <h4 class="mt-4">Últimos Pagamentos</h4>
            <ul class="payment-list">
              <li>Mensalidade Junho/2026 - <strong class="text-success">Pago</strong></li>
              <li>Mensalidade Maio/2026 - <strong class="text-success">Pago</strong></li>
              <li>Adesão - <strong class="text-success">Pago</strong></li>
            </ul>
          </div>

          <div class="partner-chart">
            <h4>Engajamento (Últimos 30 dias)</h4>
            <apexchart type="area" height="200" :options="chartOptions" :series="chartSeries"></apexchart>
          </div>
        </div>

      </div>
    </div>

    <!-- Modal Criar Parceiro -->
    <div class="partner-modal-overlay" v-if="showCreateModal">
      <div class="partner-modal-content create-modal">
        <button class="close-btn" @click="closeCreateModal"><i class="fa-solid fa-times"></i></button>
        <h3><i class="fa-solid fa-user-plus"></i> Novo Parceiro</h3>
        
        <form @submit.prevent="createPartner" class="create-partner-form">
          <div class="form-group">
            <label>Nome Completo</label>
            <input type="text" v-model="newPartner.name" required placeholder="Ex: João da Silva" />
          </div>
          <div class="form-group">
            <label>Instituição</label>
            <input type="text" v-model="newPartner.institution" required placeholder="Ex: Faculdade XYZ" />
          </div>
          <div class="form-group">
            <label>Email</label>
            <input type="email" v-model="newPartner.email" required placeholder="Ex: contato@xyz.com" />
          </div>
          <div class="form-group">
            <label>Telefone</label>
            <input type="text" v-model="newPartner.phone" @input="maskPhone" required placeholder="Ex: (11) 99999-9999" maxlength="15" />
          </div>
          <div class="form-group">
            <label>CNPJ</label>
            <input type="text" v-model="newPartner.cnpj" @input="maskCnpj" required placeholder="Ex: 00.000.000/0001-00" maxlength="18" />
          </div>
          <div class="form-group">
            <label>Tipo de Usuário</label>
            <select v-model="newPartner.type" required>
              <option value="" disabled>Selecione um tipo</option>
              <option value="manager">Gestor</option>
              <option value="user">Usuário Padrão</option>
            </select>
          </div>
          <div class="form-group">
            <label>Status</label>
            <select v-model="newPartner.active">
              <option :value="true">Ativo</option>
              <option :value="false">Inativo</option>
            </select>
          </div>
          
          <div class="form-actions">
            <button type="button" class="btn-cancel" @click="closeCreateModal">Cancelar</button>
            <button type="submit" class="btn-save" :disabled="isCreating">
              <span v-if="isCreating"><i class="fa-solid fa-spinner fa-spin"></i> Salvando...</span>
              <span v-else>Salvar Parceiro</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import requestV2 from '@/router/requestV2.js';
import '@/styles/Admin.css';

export default {
  name: 'AdminPartners',
  components: { Header },
  data() {
    return {
      partners: [],
      selectedPartner: null,
      chartOptions: {
        chart: { id: 'engagement-chart', toolbar: { show: false }, foreColor: '#aaa', fontFamily: 'Outfit, sans-serif' },
        xaxis: { categories: ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4'] },
        colors: ['#2ecc71'],
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth' },
        tooltip: { theme: 'dark' },
        grid: { borderColor: 'rgba(255,255,255,0.1)' }
      },
      chartSeries: [{ name: 'Logins na Plataforma', data: [120, 180, 250, 410] }],
      showCreateModal: false,
      isCreating: false,
      newPartner: {
        name: '',
        email: '',
        phone: '',
        cnpj: '',
        institution: '',
        type: '',
        active: true,
        is_admin: 0
      }
    }
  },
  async mounted() {
    await this.loadPartners();
  },
  methods: {
    async loadPartners() {
      try {
        const response = await requestV2.get('/partners');
        this.partners = response.data;
      } catch (err) {
        console.error('Erro ao carregar parceiros:', err);
      }
    },
    async toggleStatus(partner) {
      try {
        const response = await requestV2.put(`/partners/${partner.id}/toggle`);
        // Atualiza o parceiro na lista local
        const index = this.partners.findIndex(p => p.id === partner.id);
        if (index !== -1) {
          this.partners.splice(index, 1, { ...this.partners[index], active: response.data.active });
        }
      } catch (err) {
        console.error('Erro ao alternar status:', err);
        alert('Erro ao alternar status do parceiro.');
      }
    },
    async viewDetails(partner) {
      try {
        const response = await requestV2.get(`/partners/${partner.id}`);
        this.selectedPartner = response.data;
      } catch (err) {
        console.error('Erro ao buscar detalhes:', err);
        this.selectedPartner = partner;
      }
    },
    closeDetails() {
      this.selectedPartner = null;
    },
    openCreateModal() {
      this.newPartner = {
        name: '',
        email: '',
        phone: '',
        cnpj: '',
        institution: '',
        type: '',
        active: true,
        is_admin: 0
      };
      this.showCreateModal = true;
    },
    closeCreateModal() {
      this.showCreateModal = false;
    },
    async createPartner() {
      this.isCreating = true;
      try {
        await requestV2.post('/partners', this.newPartner);
        this.closeCreateModal();
        alert('Parceiro criado com sucesso!');
        await this.loadPartners();
      } catch (err) {
        console.error('Erro ao criar parceiro:', err);
        const serverMsg = err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message;
        alert('Erro ao criar parceiro: ' + serverMsg);
      } finally {
        this.isCreating = false;
      }
    },
    maskPhone(event) {
      let x = event.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
      if (!x[2]) {
        this.newPartner.phone = x[1];
      } else {
        this.newPartner.phone = !x[3] ? `(${x[1]}) ${x[2]}` : `(${x[1]}) ${x[2]}-${x[3]}`;
      }
    },
    maskCnpj(event) {
      let x = event.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
      if (!x[2]) {
        this.newPartner.cnpj = x[1];
      } else if (!x[3]) {
        this.newPartner.cnpj = `${x[1]}.${x[2]}`;
      } else if (!x[4]) {
        this.newPartner.cnpj = `${x[1]}.${x[2]}.${x[3]}`;
      } else if (!x[5]) {
        this.newPartner.cnpj = `${x[1]}.${x[2]}.${x[3]}/${x[4]}`;
      } else {
        this.newPartner.cnpj = `${x[1]}.${x[2]}.${x[3]}/${x[4]}-${x[5]}`;
      }
    }
  }
}
</script>

<style scoped>
.partner-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.partner-modal-content {
  background: #09105D;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 16px;
  padding: 30px;
  width: 90%;
  max-width: 800px;
  position: relative;
  box-shadow: 0 15px 40px rgba(0,0,0,0.5);
  color: #fff;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
}

.partner-modal-content h3 {
  color: #FEC401;
  margin-top: 0;
  margin-bottom: 25px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding-bottom: 15px;
}

.partner-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.partner-info p {
  margin: 10px 0;
  color: #ccc;
}

.partner-info strong {
  color: #fff;
}

.mt-4 {
  margin-top: 25px;
  color: #FEC401;
  font-size: 1.1rem;
}

.payment-list {
  list-style: none;
  padding: 0;
}

.payment-list li {
  background: rgba(255,255,255,0.05);
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.text-success {
  color: #2ecc71;
}

.partner-chart h4 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #FEC401;
}

@media (max-width: 768px) {
  .partner-grid {
    grid-template-columns: 1fr;
  }
  .create-partner-form {
    grid-template-columns: 1fr;
  }
}

.header-actions-buttons {
  display: flex;
  gap: 15px;
  align-items: center;
}

.btn-create {
  background: #FEC401;
  color: #09105D;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  transition: 0.3s;
}
.btn-create:hover {
  background: #e5b000;
  box-shadow: 0 4px 15px rgba(254, 196, 1, 0.3);
}

.create-partner-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  color: #FEC401;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.form-group input, .form-group select {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 12px;
  border-radius: 8px;
  color: #fff;
  font-family: 'Outfit', sans-serif;
}

.form-group input:focus, .form-group select:focus {
  outline: none;
  border-color: #FEC401;
}

.form-group select option {
  background: #09105D;
  color: #fff;
}

.form-group input::placeholder, .form-group select::placeholder {
  color: #ffffff44;
}

.form-actions {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 20px;
}

.btn-cancel {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: none;
  padding: 12px 25px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
}
.btn-cancel:hover {
  background: rgba(255, 255, 255, 0.2);
}

.btn-save {
  background: #FEC401;
  color: #09105D;
  border: none;
  padding: 12px 25px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: 0.3s;
}
.btn-save:hover {
  background: #e5b000;
}
.btn-save:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
